// extracted by mini-css-extract-plugin
module.exports = {"siteHeader":"styles_siteHeader__2WnF0","siteName":"styles_siteName__128xy"};